export default {
  signals: 'Signály',
  axes: 'Osi',
  addAxis: 'Pridať os',
};
